import React from "react";
import { Box, Typography } from "@mui/material";

export default function StripeOnboardingInfo({ onboardingComplete }) {
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        border: "1px solid #ccc",
        borderRadius: "4px",
        backgroundColor: "#f9f9f9",
        maxWidth: "100%",
      }}
    >
      {/* Main Heading for Bulgaria-Specific Info */}
      <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
        Important Information for Users in Bulgaria:
      </Typography>

      {/* Revolut Subsection */}
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ fontWeight: "bold", mt: 2 }}
      >
        Revolut Account IBAN:
      </Typography>
      <Typography variant="body2" component="div" sx={{ pl: 2 }}>
        <ul>
          <li>Please add your Revolut account IBAN in **Euros (€)**.</li>
          <li>Each currency in Revolut has its own unique IBAN.</li>
          <li>
            For Stripe integration with Revolut, only the **Euro (€) IBAN** is
            currently supported.
          </li>
        </ul>
      </Typography>
      <Typography
        variant="caption"
        display="block"
        sx={{ mt: 1, mb: 2, pl: 2, fontStyle: "italic" }}
      >
        Ensuring you provide the Euro IBAN will help avoid payment processing
        issues.
      </Typography>

      {!onboardingComplete && (
        <>
          {/* "Едноличен търговец" Subsection */}
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ fontWeight: "bold", mt: 2 }}
          >
            Regarding "Едноличен търговец" (Sole Proprietor):
          </Typography>
          <Typography variant="body2" component="div" sx={{ pl: 2 }}>
            <ul>
              <li>
                When setting up your Stripe account, please note that by Stripe
                standards, selecting the "Едноличен търговец" option generally
                signifies that you are operating as an individual, not a
                registered company.
              </li>
              <li>
                Please select this option if you wish to receive your payments
                as an individual.
              </li>
              <li>
                If you intend to receive payments through a registered business
                entity (e.g., OOD, AD), you should select the appropriate
                business structure option in the Stripe form.
              </li>
            </ul>
          </Typography>
        </>
      )}

      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ fontWeight: "bold", mt: 3 }}
      >
        General Information:
      </Typography>
      <Typography variant="body2" component="div" sx={{ pl: 2 }}>
        <ul>
          <li>
            Funds will be available between 7-14 days after each payment is
            successfully processed. Automated payouts on every Monday. This is
            standard Stripe payments processing and may vary slightly based on
            bank processing times
          </li>
          <li>
            Please add your personal information in Latin alphabet (English
            characters) to ensure proper processing.
          </li>
        </ul>
      </Typography>
    </Box>
  );
}
